import { SIL_TYPES } from 'src/constants';
import { formatTimeToInt } from 'src/utils';

/**
 *
 * @param {leave[]} leaves
 * @param {string} time time in HH:mm format
 */
function hasOB(leaves, time) {
  return leaves.some(
    leave =>
      leave.ixSILType === SIL_TYPES.OB &&
      leave.ixTime1 <= formatTimeToInt(time) &&
      leave.ixTime2 >= formatTimeToInt(time)
  );
}

export default hasOB;
